export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^(CP)?\s?((((1[1-7])|([23][1-3]))01)|(111[67])|(1204)|(15((02)|(1[23])))|(2103)|(22[01]5)|(2320))$/i));
    }
}
